var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscribeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,11.06c-2.11,0-3.83-1.72-3.83-3.83s1.72-3.83,3.83-3.83,3.83,1.72,3.83,3.83-1.72,3.83-3.83,3.83Zm0-6.67c-1.56,0-2.83,1.27-2.83,2.83s1.27,2.83,2.83,2.83,2.83-1.27,2.83-2.83-1.27-2.83-2.83-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.78,21.11h-1.5c0-3.46-2.82-6.28-6.28-6.28s-6.28,2.82-6.28,6.28h-1.5c0-4.29,3.49-7.78,7.78-7.78s7.78,3.49,7.78,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.76,21.11h-1c0-2.07-1.69-3.76-3.76-3.76s-3.76,1.69-3.76,3.76h-1c0-2.63,2.14-4.76,4.76-4.76s4.76,2.14,4.76,4.76Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.26,
    y: 8.79,
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.26,
    y: 11.79,
    width: 7,
    height: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeIcon);
export default __webpack_public_path__ + "static/media/Subscribe-Icon.b1304d60053c6fdb81c3d04282a7709e.svg";
export { ForwardRef as ReactComponent };